export default {
	id: "surface-book",
	title: "Surface Book",
	company: "Microsoft",
	styles: [
		{
			title: "normal",
			pos: ["6.2%", "13.2%", "10.2%", "13.2%"],
			colors: [
				{
					title: "Silver",
					hex: "#D5D2CF",
					img: require("./original/silver.png")
				}
			]
		}
	]
};
